/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Prepaid_LeftInputs */



/**
* | output |
* | --- |
* | "Remaining" |
*
* @param {Partner_Org_Contract_Prepaid_LeftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_prepaid_left = /** @type {((inputs?: Partner_Org_Contract_Prepaid_LeftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Prepaid_LeftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbleibend")
	return /** @type {LocalizedString} */ ("Remaining")
});